import { useState } from "react";
import { Menu, X } from "lucide-react";
import ContactForm from "./ContactForm";

const navLinks = [
  { label: "Strona główna", href: "/#hero" },
  { label: "Usługi", href: "/#uslugi" },
  { label: "Cennik", href: "/cennik" },
  { label: "Portfolio", href: "/#portfolio" },
  { label: "Dlaczego my", href: "/#dlaczego" },
  { label: "Baza wiedzy", href: "/baza-wiedzy" },
  { label: "Wizualizator", href: "/wizualizator" },
  { label: "Kontakt", href: "/#kontakt" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [showForm, setShowForm] = useState(false);

  return (
    <>
      <nav className="fixed top-0 left-0 right-0 z-50 bg-card/90 backdrop-blur-md border-b border-border">
        <div className="container mx-auto flex items-center justify-between h-16 px-4">
          <a href="/" className="flex items-center gap-2">
            <span className="text-2xl font-display font-bold text-primary">
              Best<span className="text-gradient-gold">Site</span>
            </span>
          </a>

          {/* Desktop */}
          <ul className="hidden lg:flex items-center gap-6">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  className="text-sm font-medium text-muted-foreground hover:text-primary transition-colors"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>

          <button
            onClick={() => setShowForm(true)}
            className="hidden lg:inline-flex items-center px-5 py-2.5 rounded-lg bg-secondary text-secondary-foreground font-semibold text-sm hover:opacity-90 transition-opacity"
          >
            Darmowa wycena
          </button>

          {/* Mobile toggle */}
          <button
            className="lg:hidden text-foreground"
            onClick={() => setOpen(!open)}
            aria-label="Menu"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile menu */}
        {open && (
          <div className="lg:hidden bg-card border-b border-border px-4 pb-4">
            <ul className="flex flex-col gap-3">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="block py-2 text-sm font-medium text-muted-foreground hover:text-primary"
                    onClick={() => setOpen(false)}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
              <li>
                <button
                  onClick={() => { setOpen(false); setShowForm(true); }}
                  className="w-full py-2.5 text-center rounded-lg bg-secondary text-secondary-foreground font-semibold text-sm"
                >
                  Darmowa wycena
                </button>
              </li>
            </ul>
          </div>
        )}
      </nav>

      {/* Modal overlay */}
      {showForm && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
          <div className="absolute inset-0 bg-foreground/40 backdrop-blur-sm" onClick={() => setShowForm(false)} />
          <div className="relative bg-card rounded-2xl shadow-warm-lg p-6 border border-border w-full max-w-md max-h-[90vh] overflow-y-auto animate-fade-in">
            <button
              onClick={() => setShowForm(false)}
              className="absolute top-3 right-3 text-muted-foreground hover:text-foreground transition-colors"
              aria-label="Zamknij"
            >
              <X size={20} />
            </button>
            <h2 className="text-xl font-display font-bold text-foreground mb-1">
              Darmowa wycena
            </h2>
            <p className="text-xs text-muted-foreground mb-4">
              Opisz swój projekt — odezwiemy się w ciągu 24h
            </p>
            <ContactForm compact onSuccess={() => setTimeout(() => setShowForm(false), 3000)} />
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
